import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'root/components/molecules/Select';

export const FormSelect = ({
  name,
  control,
  options,
  rules,
  defaultValue,
  ...props
}) => (
  <Controller
    control={control}
    defaultValue={defaultValue}
    name={name}
    render={({ onChange, onBlur, value, name: renderName }) => (
      <Select
        name={renderName}
        onBlur={onBlur}
        onChange={(v) => onChange(v)}
        options={options}
        value={value}
        {...props}
      />
    )}
    rules={rules}
  />
);

FormSelect.propTypes = {
  control: PropTypes.shape(), // provided by react-hook-form
  defaultValue: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(PropTypes.any)),
    PropTypes.shape(PropTypes.any),
    PropTypes.string,
    PropTypes.any,
  ]),
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  rules: PropTypes.shape({}),
};

FormSelect.defaultProps = {
  control: {},
  defaultValue: undefined,
  options: [],
  rules: undefined,
};

export default FormSelect;
